<template>
  <div
    v-if="props.data.length > 0"
    class="flex gap-2 overflow-x-auto hide-scroll-bar w-full"
    :data-testid="props.dataTestid"
  >
    <div
      v-for="item in props.data"
      :key="item.id"
      :class="twMerge('min-w-[132px]', props.data.length === 8 && 'w-full')"
      :data-testid="props.dataTestid + '-item'"
    >
      <component
        :is="item.landingPageUrl ? NuxtLinkWithLocale : 'div'"
        :to="item.landingPageUrl"
        :class="twMerge('relative rounded-lg overflow-hidden', item.landingPageUrl && 'block')"
      >
        <TsImage
          v-if="item.image"
          :src="`${item.image}?width=148&height=148&format=webp`"
          :alt="item.image_alt"
          class="w-full"
          :width="isMobile ? '132' : '148'"
          :height="isMobile ? '132' : '148'"
          loading="lazy"
        />
        <TsTypography
          v-if="item.image_tag"
          variant="xs"
          align="center"
          append-class="mb-0 bg-primary absolute bottom-0 px-1 py-2.5 w-full text-idle-white"
        >
          {{ item.image_tag }}
        </TsTypography>
      </component>
      <component
        :is="item.landingPageUrl ? NuxtLinkWithLocale : 'div'"
        v-if="item.title"
        :to="item.landingPageUrl"
        :class="twMerge('mt-3', item.landingPageUrl && 'block')"
      >
        <TsTypography
          variant="sm"
          align="center"
          weight="semibold"
          append-class="mb-0 text-natural-black hyphens-auto"
          size="sm"
        >
          <span v-html="item.title" />
        </TsTypography>
      </component>
    </div>
  </div>
</template>

<script setup lang="ts">
import { twMerge } from 'tailwind-merge';
const { isMobile } = useDevice();
type Data = {
  id: number;
  landingPageUrl?: string;
  image: string;
  image_alt: string;
  image_tag: string;
  title: string;
};

type Props = {
  data?: Data[];
  dataTestid?: string;
};

const props = withDefaults(defineProps<Props>(), {
  dataTestid: '',
  data: () => [
    {
      id: 1,
      image: '/images/screws.png',
      image_alt: 'Get up to 50% off on screws',
      image_tag: 'Get up to 50% off',
      title: 'Screws & Fasteners',
    },
    {
      id: 2,
      image: '/images/battries.png',
      image_alt: 'Get up to 50% off on batteries',
      image_tag: 'Get up to 50% off',
      title: 'Batteries & Chargers',
    },
    {
      id: 3,
      image: '/images/cordless.png',
      image_alt: 'Get up to 50% off on cordless tools',
      image_tag: 'Get up to 50% off',
      title: 'Cordless Tool',
    },
    {
      id: 4,
      image: '/images/trouser.png',
      image_alt: 'Get up to 50% off on trousers',
      image_tag: 'Get up to 50% off',
      title: 'Work Trousers',
    },
    {
      id: 5,
      image: '/images/grinding.png',
      image_alt: 'Get up to 50% off on grind tools',
      image_tag: 'Get up to 50% off',
      title: 'Grinding Machines',
    },
    {
      id: 6,
      image: '/images/mowers.png',
      image_alt: 'Get up to 50% off on lawn mowers',
      image_tag: 'Get up to 50% off',
      title: 'Lawn Mowers',
    },
    {
      id: 7,
      image: '/images/hammers.png',
      image_alt: 'Get up to 50% off on hammers',
      image_tag: 'Get up to 50% off',
      title: 'Hammer',
    },
    {
      id: 8,
      image: '/images/showers.png',
      image_alt: 'Get up to 50% off on showers',
      image_tag: 'Get up to 50% off',
      title: 'Taps & Showers',
    },
  ],
});

const NuxtLinkWithLocale = resolveComponent('NuxtLinkWithLocale');
</script>
